<template>
  <div>
    <div align="left">
      <span style="margin-right: 5px">区县详情汇总</span>
      <el-date-picker
        v-model="dateRange"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd">
      </el-date-picker>

      <el-select v-model="area" filterable placeholder="请选择区域" style="width: 200px">
        <el-option label="全部" value=""></el-option>
        <el-option
          v-for="item in allArea"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>

      <el-select v-model="level" placeholder="医院级别" style="width: 150px" @change="buildTabs">
        <el-option label="全部级别" value="all"></el-option>
        <el-option label="二级及以上" value="secondPlus"></el-option>
        <el-option label="二级以下" value="belowSecond"></el-option>
      </el-select>

      <el-button type="primary" icon="el-icon-circle-plus" :loading="loading" @click="getCountyReport" >查询</el-button>

      <el-button type="success" icon="el-icon-download" :disabled="tabs.length===0" @click="exportExcel" >导出Excel</el-button>

    </div>

    <el-tabs v-model="activeName" type="card" v-if="tabs.length>0" style="margin-top: 10px">
      <el-tab-pane
        v-for="(tab,index) in tabs"
        :key="tab.name"
        :label="tab.name"
        :name="tab.name">
        <el-table
          :data="tab.list"
          border
          style="width: 100%"
          max-height="100%">
          <el-table-column
            type="index"
            label="序号"
            width="70"
            :index="indexMethod">
          </el-table-column>
          <el-table-column
            prop="name"
            label="医疗机构名称"
            width="300">
          </el-table-column>
          <el-table-column
            prop="code"
            label="编号"
            width="140">
          </el-table-column>
          <el-table-column label="感染性医疗废物">
            <el-table-column
              prop="infectious_num"
              label="数量"
              width="150">
            </el-table-column>
            <el-table-column
              prop="infectious_weight"
              label="重量（KG）"
              width="150"
              :formatter="summaryFormatter">
            </el-table-column>
          </el-table-column>
          <el-table-column label="损伤性医疗废物">
            <el-table-column
              prop="injure_num"
              label="数量"
              width="150">
            </el-table-column>
            <el-table-column
              prop="injure_weight"
              label="重量（KG）"
              width="150"
              :formatter="summaryFormatter">
            </el-table-column>
          </el-table-column>
          <el-table-column
            prop="total_num"
            label="总数量"
            width="120">
          </el-table-column>
          <el-table-column
            prop="total_weight"
            label="总重量（KG）"
            width="130"
            :formatter="summaryFormatter">
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>


<script>
import coder from "./enum.js"
import hospitalGrade from "./hospitalGrade.js"

function crcTable() {
  let c, crcTable = [];
  for (let n = 0; n < 256; n++) {
    c = n;
    for (let k = 0; k < 8; k++) c = (c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1);
    crcTable[n] = c >>> 0;
  }
  return crcTable;
}
const crcT = crcTable();
function crc32(data) {
  let crc = 0xFFFFFFFF;
  for (let i = 0; i < data.length; i++) crc = (crc >>> 8) ^ crcT[(crc ^ data[i]) & 0xFF];
  return (crc ^ 0xFFFFFFFF) >>> 0;
}
function escapeXml(s) {
  return ('' + s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
function colName(i) {
  let s = '', i2 = i;
  while (i2 >= 0) { s = String.fromCharCode(65 + (i2 % 26)) + s; i2 = Math.floor(i2 / 26) - 1; }
  return s;
}
function textWidth(s) {
  let w = 0;
  for (let i = 0; i < s.length; i++) {
    w += (s.charCodeAt(i) > 255) ? 2 : 1;
  }
  return w;
}
function sheetXml(headers, rows, group, title) {
  let xml = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>';
  let colWidths = [];
  let totalCols = 0;
  if (group) {
    totalCols = group.top[group.top.length-1].c2 + 1;
    colWidths = [];
    for (let c = 0; c < totalCols; c++) {
      let maxW = 10;
      for (let t of group.top) {
        if (c >= t.c1 && c <= t.c2) maxW = Math.max(maxW, textWidth(t.label));
      }
      for (let t of group.bottom) {
        if (c >= t.c1 && c <= t.c2) maxW = Math.max(maxW, textWidth(t.label));
      }
      for (let r = 0; r < rows.length; r++) {
        let w = textWidth('' + rows[r][c]);
        if (w > maxW) maxW = w;
      }
      colWidths.push(maxW + 4);
    }
  } else {
    totalCols = headers.length;
    for (let c = 0; c < headers.length; c++) {
      let maxW = textWidth(headers[c]);
      for (let r = 0; r < rows.length; r++) {
        let w = textWidth('' + rows[r][c]);
        if (w > maxW) maxW = w;
      }
      colWidths.push(Math.max(10, maxW + 4));
    }
  }
  xml += '<worksheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main"><cols>';
  for (let c = 0; c < colWidths.length; c++) {
    xml += '<col min="' + (c + 1) + '" max="' + (c + 1) + '" width="' + colWidths[c] + '" customWidth="1"/>';
  }
  xml += '</cols><sheetData>';
  let merges = [];
  let startRow = 1;
  if (title) {
    xml += '<row r="1" ht="24" customHeight="1"><c r="A1" s="1" t="inlineStr"><is><t>' + escapeXml(title) + '</t></is></c></row>';
    merges.push('<mergeCell ref="A1:' + colName(totalCols - 1) + '1"/>');
    startRow = 2;
  }
  if (group) {
    xml += '<row r="' + startRow + '" ht="22" customHeight="1">';
    for (let c = 0; c < group.top.length; c++) {
      let t = group.top[c];
      let ref = colName(t.c1) + startRow;
      if (t.c2 > t.c1) merges.push('<mergeCell ref="' + colName(t.c1) + startRow + ':' + colName(t.c2) + startRow + '"/>');
      xml += '<c r="' + ref + '" s="1" t="inlineStr"><is><t>' + escapeXml(t.label) + '</t></is></c>';
    }
    xml += '</row>';
    xml += '<row r="' + (startRow + 1) + '" ht="20" customHeight="1">';
    for (let c = 0; c < group.bottom.length; c++) {
      let t = group.bottom[c];
      if (t.c2 > t.c1) merges.push('<mergeCell ref="' + colName(t.c1) + (startRow + 1) + ':' + colName(t.c2) + (startRow + 1) + '"/>');
      xml += '<c r="' + colName(t.c1) + (startRow + 1) + '" s="1" t="inlineStr"><is><t>' + escapeXml(t.label) + '</t></is></c>';
    }
    for (let c = 0; c < group.vert.length; c++) {
      let col = group.vert[c];
      merges.push('<mergeCell ref="' + colName(col) + startRow + ':' + colName(col) + (startRow + 1) + '"/>');
    }
    xml += '</row>';
    for (let r = 0; r < rows.length; r++) {
      xml += '<row r="' + (r + startRow + 2) + '" ht="20" customHeight="1">';
      for (let c = 0; c < rows[r].length; c++) {
        let cell = rows[r][c];
        let ref = colName(c) + (r + startRow + 2);
        if (typeof cell === 'number') {
          xml += '<c r="' + ref + '" s="2"><v>' + cell + '</v></c>';
        } else {
          xml += '<c r="' + ref + '" s="2" t="inlineStr"><is><t>' + escapeXml(cell) + '</t></is></c>';
        }
      }
      xml += '</row>';
    }
  } else {
    xml += '<row r="' + startRow + '" ht="22" customHeight="1">';
    for (let c = 0; c < headers.length; c++) {
      xml += '<c r="' + colName(c) + startRow + '" s="1" t="inlineStr"><is><t>' + escapeXml(headers[c]) + '</t></is></c>';
    }
    xml += '</row>';
    for (let r = 0; r < rows.length; r++) {
      xml += '<row r="' + (r + startRow + 1) + '" ht="20" customHeight="1">';
      for (let c = 0; c < headers.length; c++) {
        let cell = rows[r][c];
        let ref = colName(c) + (r + startRow + 1);
        if (typeof cell === 'number') {
          xml += '<c r="' + ref + '" s="2"><v>' + cell + '</v></c>';
        } else {
          xml += '<c r="' + ref + '" s="2" t="inlineStr"><is><t>' + escapeXml(cell) + '</t></is></c>';
        }
      }
      xml += '</row>';
    }
  }
  xml += '</sheetData>';
  xml += '<mergeCells count="' + merges.length + '">' + merges.join('') + '</mergeCells>';
  xml += '</worksheet>';
  return xml;
}
async function buildXlsxBlob(sheets) {
  const enc = new TextEncoder();
  const parts = [];
  parts.push(['[Content_Types].xml', enc.encode(
    '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' +
    '<Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types">' +
    '<Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml"/>' +
    '<Default Extension="xml" ContentType="application/xml"/>' +
    '<Override PartName="/xl/workbook.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml"/>' +
    '<Override PartName="/xl/styles.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml"/>' +
    sheets.map((s, i) => '<Override PartName="/xl/worksheets/sheet' + (i + 1) + '.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml"/>').join('') +
    '</Types>')]);
  parts.push(['_rels/.rels', enc.encode(
    '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' +
    '<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">' +
    '<Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Target="xl/workbook.xml"/>' +
    '</Relationships>')]);
  parts.push(['xl/workbook.xml', enc.encode(
    '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' +
    '<workbook xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships">' +
    '<sheets>' +
    sheets.map((s, i) => '<sheet name="' + escapeXml(s.name) + '" sheetId="' + (i + 1) + '" r:id="rId' + (i + 1) + '"/>').join('') +
    '</sheets></workbook>')]);
  parts.push(['xl/_rels/workbook.xml.rels', enc.encode(
    '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' +
    '<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">' +
    sheets.map((s, i) => '<Relationship Id="rId' + (i + 1) + '" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet" Target="worksheets/sheet' + (i + 1) + '.xml"/>').join('') +
    '<Relationship Id="rId' + (sheets.length + 1) + '" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles" Target="styles.xml"/>' +
    '</Relationships>')]);
  parts.push(['xl/styles.xml', enc.encode(
    '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' +
    '<styleSheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main">' +
    '<numFmts count="0"/>' +
    '<fonts count="2"><font><sz val="11"/><name val="Calibri"/></font><font><b/><sz val="11"/><color rgb="FFFFFFFF"/><name val="Calibri"/></font></fonts>' +
    '<fills count="3"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill><fill><patternFill patternType="solid"><fgColor rgb="FF4472C4"/><bgColor indexed="64"/></patternFill></fill></fills>' +
    '<borders count="1"><border><left style="thin"><color auto="1"/></left><right style="thin"><color auto="1"/></right><top style="thin"><color auto="1"/></top><bottom style="thin"><color auto="1"/></bottom><diagonal/></border></borders>' +
    '<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>' +
    '<cellXfs count="3"><xf numFmtId="0" fontId="0" fillId="0" borderId="0" xfId="0"/><xf numFmtId="0" fontId="1" fillId="2" borderId="0" xfId="0" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="0" fillId="0" borderId="0" xfId="0" applyBorder="1"/></cellXfs>' +
    '<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>' +
    '</styleSheet>')]);
  sheets.forEach((s, i) => {
    parts.push(['xl/worksheets/sheet' + (i + 1) + '.xml', enc.encode(sheetXml(s.headers, s.data, s.group, s.title))]);
  });

  const entries = [];
  for (const [name, data] of parts) {
    const cs = new CompressionStream('deflate-raw');
    const writer = cs.writable.getWriter();
    writer.write(data);
    writer.close();
    const reader = cs.readable.getReader();
    const chunks = [];
    let total = 0;
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      chunks.push(value);
      total += value.length;
    }
    const comp = new Uint8Array(total);
    let off = 0;
    for (const c of chunks) { comp.set(c, off); off += c.length; }
    entries.push({ name, data, comp, crc: crc32(data) });
  }

  let offset = 0;
  const localParts = [];
  for (const e of entries) {
    const nameArr = new TextEncoder().encode(e.name);
    localParts.push({ e, nameArr, offset });
    offset += 30 + nameArr.length + e.comp.length;
  }

  const chunks = [];
  for (const { e, nameArr: name, offset } of localParts) {
    const lh = new DataView(new ArrayBuffer(30));
    lh.setUint32(0, 0x04034b50, true);
    lh.setUint16(4, 20, true);
    lh.setUint16(6, 0x0800, true);
    lh.setUint16(8, 8, true);
    lh.setUint32(14, e.crc, true);
    lh.setUint32(18, e.comp.length, true);
    lh.setUint32(22, e.data.length, true);
    lh.setUint16(26, name.length, true);
    lh.setUint16(28, 0, true);
    chunks.push(new Uint8Array(lh.buffer), name, e.comp);
  }
  const centralStart = offset;
  let centralSize = 0;
  for (const { e, nameArr: name, offset } of localParts) {
    const ch = new DataView(new ArrayBuffer(46));
    ch.setUint32(0, 0x02014b50, true);
    ch.setUint16(4, 20, true);
    ch.setUint16(6, 20, true);
    ch.setUint16(8, 0x0800, true);
    ch.setUint16(10, 8, true);
    ch.setUint32(16, e.crc, true);
    ch.setUint32(20, e.comp.length, true);
    ch.setUint32(24, e.data.length, true);
    ch.setUint16(28, name.length, true);
    ch.setUint16(30, 0, true);
    ch.setUint16(32, 0, true);
    ch.setUint16(34, 0, true);
    ch.setUint16(36, 0, true);
    ch.setUint32(38, 0, true);
    ch.setUint32(42, offset, true);
    chunks.push(new Uint8Array(ch.buffer), name);
    centralSize += 46 + name.length;
  }
  const eocd = new DataView(new ArrayBuffer(22));
  eocd.setUint32(0, 0x06054b50, true);
  eocd.setUint16(4, 0, true);
  eocd.setUint16(6, 0, true);
  eocd.setUint16(8, localParts.length, true);
  eocd.setUint16(10, localParts.length, true);
  eocd.setUint32(12, centralSize, true);
  eocd.setUint32(16, centralStart, true);
  eocd.setUint16(20, 0, true);
  chunks.push(new Uint8Array(eocd.buffer));
  return new Blob(chunks, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
}
function buildXlsxWorkbook(tabs, fileName, group, rangeStr, levelStr) {
  const sheets = [];
  for (let i = 0; i < tabs.length; i++) {
    const data = tabs[i].list.map((d, idx) => [idx + 1, d.name, d.code, d.infectious_num, d.infectious_weight, d.injure_num, d.injure_weight, d.total_num, d.total_weight]);
    sheets.push({ name: tabs[i].name, headers: [], group: group, data: data, title: tabs[i].name + rangeStr + '（' + levelStr + '）' });
  }
  buildXlsxBlob(sheets).then(blob => {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);
  });
}

export default {
  methods: {
    indexMethod(index) {
      return index + 1;
    },
    summaryFormatter(row, column, cellValue){
      if (row.isSummary && cellValue!==undefined && cellValue!==null) {
        return Number(cellValue).toFixed(2);
      }
      return cellValue;
    },
    getCountyReport(){
      if (this.loading){ return }
      if (this.dateRange==null||this.dateRange.length!==2||this.dateRange[0]===''||this.dateRange[1]===''){
        this.$alert('请选择日期范围', '错误', {
          confirmButtonText: '确定'
        });
        return
      }
      this.loading=true;
      window.ws.Call("W2S_CountyDetailsReport", this.dateRange[0], this.dateRange[1], this.area);
    },
    levelMatch(code){
      if (this.level==='all') return true;
      let plus=hospitalGrade.isSecondPlus(code);
      return this.level==='secondPlus'?plus:!plus;
    },
    levelName(){
      if (this.level==='secondPlus') return '二级及以上';
      if (this.level==='belowSecond') return '二级以下';
      return '全部级别';
    },
    buildTabs(){
      if (this.rawRes===undefined||this.rawRes===null){ return }
      let tabs = [];
      for(let i=0;i<this.rawRes.length;i++){
        let rows = [];
        for(let j=0;j<this.rawRes[i].List.length;j++){
          let d=this.rawRes[i].List[j];
          if (!this.levelMatch(d.Code)) continue;
          rows.push({
            name:d.Name,
            code:d.Code,
            infectious_num:d.InfectiousNum,
            infectious_weight:d.InfectiousWeight/1000,
            injure_num:d.InjureNum,
            injure_weight:d.InjureWeight/1000,
            total_num:d.InfectiousNum+d.InjureNum,
            total_weight:(d.InfectiousWeight+d.InjureWeight)/1000,
          });
        }
        rows.sort((a,b)=>a.code.localeCompare(b.code));
        let sumInfNum = 0, sumInfWeight = 0, sumInjNum = 0, sumInjWeight = 0;
        for(let j=0;j<rows.length;j++){
          sumInfNum += rows[j].infectious_num;
          sumInfWeight += rows[j].infectious_weight;
          sumInjNum += rows[j].injure_num;
          sumInjWeight += rows[j].injure_weight;
        }
        rows.push({
          name:'合计',
          code:'',
          infectious_num:sumInfNum,
          infectious_weight:sumInfWeight,
          injure_num:sumInjNum,
          injure_weight:sumInjWeight,
          total_num:sumInfNum+sumInjNum,
          total_weight:sumInfWeight+sumInjWeight,
          isSummary:true,
        });
        tabs.push({name:this.rawRes[i].Name,list:rows});
      }
      this.tabs=tabs;
      if (tabs.length>0){
        this.activeName=tabs[0].name;
      }else{
        this.activeName='';
      }
    },
    exportExcel(){
      if (this.tabs.length===0){ return }
      let $this=this;
      let start = this.dateRange[0].replace(/-/g,'.');
      let end = this.dateRange[1].replace(/-/g,'.');
      let fileName = '区域明细统计表（'+start+'-'+end+'，'+this.levelName()+'）.xlsx';
      let rangeStr = start + '-' + end;
      let group = {
        top: [
          {label:'序号', c1:0, c2:0},
          {label:'医疗机构名称', c1:1, c2:1},
          {label:'编号', c1:2, c2:2},
          {label:'感染性医疗废物', c1:3, c2:4},
          {label:'损伤性医疗废物', c1:5, c2:6},
          {label:'总数量', c1:7, c2:7},
          {label:'总重量（KG）', c1:8, c2:8}
        ],
        bottom: [
          {label:'数量', c1:3, c2:3},
          {label:'重量（KG）', c1:4, c2:4},
          {label:'数量', c1:5, c2:5},
          {label:'重量（KG）', c1:6, c2:6}
        ],
        vert: [0,1,2,7,8]
      };
      buildXlsxWorkbook(this.tabs, fileName, group, rangeStr, this.levelName());
    },
    dateFormat(fmt, date) {
      let ret;
      const opt = {
        "Y+": date.getFullYear().toString(),
        "m+": (date.getMonth() + 1).toString(),
        "d+": date.getDate().toString(),
      };
      for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
          fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
        };
      };
      return fmt;
    },
  },
  mounted() {
    let $this=this;
    console.log("###Page loaded !");

    if (window.allArea===null||window.allArea===undefined||window.allArea.length===0){
      window.ws.AddFunc("S2W_GetAllAreaRes",function(list){
        let names = [];
        for(let i=0;i<list.length;i++){
          names.push({value:list[i],label:list[i]})
        }
        $this.allArea=names;
        window.allArea=names;
      });
      window.ws.Call("W2S_GetAllArea")
    }else{
      this.allArea=window.allArea;
    }

    let now = new Date();
    let firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
    let lastDay = new Date(now.getFullYear(), now.getMonth()+1, 0);
    this.dateRange=[this.dateFormat("YYYY-mm-dd",firstDay),this.dateFormat("YYYY-mm-dd",lastDay)];

    window.ws.AddFunc("S2W_CountyDetailsReportRes",function (code,err,res) {
      console.log("S2W_CountyDetailsReportRes:",code,err,res)
      if (code==coder.OK){
        $this.loading=false;
        $this.rawRes=res;
        $this.buildTabs();
      }else{
        $this.loading=false;
        $this.$alert(err+'('+code+')', '错误', {
          confirmButtonText: '确定'
        });
      }
    });
  },
  data() {
    return {
      tabs: [],
      activeName:'',
      dateRange: [],
      area: '',
      level:'all',
      rawRes:null,
      allArea:[],
      loading:false,
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/view/CountyDetailsReport.vue